import VImg from "./VImg";
export { VImg };
export default VImg;